
import bowser from 'bowser';
import navigationViewport from './navigation--viewport.js';

navigationViewport.then(function () {
  var mainNavi = document.querySelector('.navigation--main');
  var changeEventName = bowser.ios ? 'custom-change' : 'change';
  if (null === mainNavi) {
    return;
  }

  mainNavi.addEventListener('tap', function (event) {
    var target = event.target;
    if (target
      && target.tagName === 'A'
      && target.classList.contains('navigation__item-link--sub')
      && target.previousElementSibling !== null
      && target.previousElementSibling.tagName === 'INPUT'
      && target.previousElementSibling.classList.contains('navigation__item-state')) {

      event.preventDefault();

      if(window.fitNavigationViewport === 'mobile') {
        target.previousElementSibling.checked = !target.previousElementSibling.checked;
        target.previousElementSibling.dispatchEvent(new CustomEvent(changeEventName, {bubbles: true}));
      } else if(window.fitNavigationViewport === 'desktop') {
        target.parentNode.dispatchEvent(new CustomEvent('navigation-item-selected', {bubbles: true}));
      }
    }
  });
});
